import { useMutation } from "@tanstack/react-query";

import { axiosInstance } from "../../lib/axios";

interface TelegramOtpRequest {
  phone_number: string;
}

interface TelegramOtpResponse {
  success: boolean;
  message: string;
}

export const useTelegramSendOtp = () => {
  return useMutation({
    mutationFn: async (data: TelegramOtpRequest) => {
      return await axiosInstance.post<TelegramOtpResponse>(
        "/connect/telegram/otp",
        data,
      );
    },
    onError: (error) => {
      console.error("Telegram OTP send failed:", error);
    },
  });
};
